import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import SendIcon from "@mui/icons-material/Send";
import { Link } from "react-router-dom";
import { FormControl, Select, MenuItem } from "@mui/material";
import Chip from "@material-ui/core/Chip";
import Checkbox from "@mui/material/Checkbox";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Loader from "components/Loader";
import FastRewindIcon from "@mui/icons-material/FastRewind";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const AddPrerequisiteCoursesModal = ({
  totalCourses,
  courseId,
  prerequisiteCoursesModalOpen,
  setPrerequisiteCoursesModalOpen,
  prerequisiteCourses,
  handleCourseSelection,
  handleAddPrerequisiteCourses,
}) => {
  return (
    <Modal
      open={prerequisiteCoursesModalOpen}
      onClose={() => {
        setPrerequisiteCoursesModalOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          ...style,
          width: '90vw',
          maxWidth: '600px',
          maxHeight: '80vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          borderRadius: 2,
          p: 3,
          mx: 'auto',
        }}
      >
        <div className="text-lg text-center font-bold sm:text-xl mb-4">
          Select Courses
        </div>

        <div className="overflow-y-auto max-h-60 w-full">
          <table className="min-w-full text-sm text-left border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-white font-semibold border-b">Course Title</th>
                <th className="px-4 py-2 text-white font-semibold border-b">Select</th>
              </tr>
            </thead>
            <tbody>
              {totalCourses &&
                totalCourses
                  .filter((course) => course._id !== courseId)
                  .map((course) => (
                    <tr key={course._id} className="border-b hover:bg-gray-50">
                      <td className="px-4 py-2">{course.title}</td>
                      <td className="px-4 py-2">
                        <input
                          type="checkbox"
                          checked={prerequisiteCourses.includes(course._id)}
                          // onChange={() => handleCourseSelection(course._id)}
                          onChange={(e) => handleCourseSelection(e, course._id)}
                          className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                        />
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>


        <div className="flex md:flex-col  flex-row justify-end items-center mt-4 gap-2">
          <Button variant="contained" onClick={handleAddPrerequisiteCourses}>
            Add
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setPrerequisiteCoursesModalOpen(false);
            }}
          >
            Close
          </Button>
        </div>
      </Box>
    </Modal>

  );
};

export default AddPrerequisiteCoursesModal;
